import $ from "jquery";
import { initMiniCardsCustomPopups } from "scripts/components/minicardPopup"

const closeFavoriteModal = () => {
  $(".js_close_favorite_modal").on("click", function () {
    $(this).closest(".modal").fadeOut();
  });
};

export const initMinicardEvents = () => {
  initMiniCardsCustomPopups();
  closeFavoriteModal();
};
